// extracted by mini-css-extract-plugin
export var infoRow = "_bn-2";
export var labelContainer = "_bn-0";
export var rightInfo = "_bn-1";